<template>
  <section class="section" id="configs-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <store-header
        v-if="storeBeingManaged"
        :storeBeingManaged="storeBeingManaged"
      />

      <div v-if="storeBeingManaged && permissions.manageBuyNowPayLater">
        <hr class="separator" />
        <buy-now-pay-later />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import storeHeader from "../common/StoreHeader";
import buyNowPayLater from "./BuyNowPayLater";

export default {
  mixins: [common],

  components: {
    storeHeader,
    buyNowPayLater
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "permissions"])
  }
};
</script>

<style scoped>
#configs-panel {
  min-height: 100vh;
  padding: 1.5rem;
  background-color: #f8f7fa;
}
.separator {
  background-color: #e5e5e5;
}
</style>
